// removed by extract-text-webpack-plugin
module.exports = {"IP7":"IP7__IP7__1VRWB","IP7Percentage":"IP7__IP7Percentage__65Uto","percentageInputContainer":"IP7__percentageInputContainer__2v5XJ","indexLabel":"IP7__indexLabel__2lNGE","invalid":"IP7__invalid__1AMn6","validationMessage":"IP7__validationMessage__1w587","instructionMsg":"IP7__instructionMsg__2EQkr"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/IP7/IP7.css
// module id = 504
// module chunks = 0